import { Component } from '@angular/core';

@Component({
  selector: 'app-interceptor-error',
  templateUrl: './interceptor-error.component.html',
  styleUrls: ['./interceptor-error.component.scss']
})
export class InterceptorErrorComponent {
  errorMessage: string = 'An unexpected error occurred. Please try again later.';

}
